module.exports = __webpack_public_path__ + "static/img/fs.35e3015.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/preview_img/fs.jpg
// module id = aLrc
// module chunks = 35